import { useTranslation } from 'react-i18next';
import {
  Alert02Icon,
  GiftIcon,
  PencilEdit01Icon,
  ShoppingBasketFavorite03Icon,
  Ticket02Icon,
} from 'hugeicons-react';
import PropTypes from 'prop-types';
import ModalDialog from '@components/ui/ModalDialog.component.jsx';
import RuleItem from '@components/ui/RuleItem.component.jsx';

function RulesDialog({ open, onClose }) {
  const { t } = useTranslation();

  return (
    <ModalDialog
      variant={'gradient'}
      buttonText={t('common.close')}
      open={open}
      onClose={onClose}
      title={t('rules.title')}
    >
      <div className="text-event-light/90 text-base text-center px-2 font-sans break-words">
        <h3 className="text-md font-bold font-wide mb-3 text-wrap">
          {t('rules.description.header')}
        </h3>
        <div className="text-sm font-sans mb-4 leading-5">
          <p>{t('rules.description.summary.start')}</p>
          <p className={'my-1.5 font-bold font-wide text-event-light'}>
            {t('rules.description.summary.accent')}
          </p>
          <p>{t('rules.description.summary.end')}</p>
          <p className={'my-3 text-event-light'}>
            <span className={'font-wide font-bold'}>
              {t('rules.description.summary.port_mall.part1')}
            </span>
            {t('rules.description.summary.port_mall.part2')}
          </p>

          <p className={'mb-1 font-bold'}>
            {t('rules.description.summary.sponsors')}
          </p>
        </div>
        <ul className="my-3 text-start space-y-2 text-xs">
          <RuleItem
            icon={<ShoppingBasketFavorite03Icon />}
            text={t('rules.description.first')}
          />
          <RuleItem
            icon={<PencilEdit01Icon />}
            text={t('rules.description.second')}
          />
          <RuleItem
            icon={<Ticket02Icon />}
            text={t('rules.description.third')}
          />
          <RuleItem icon={<GiftIcon />} text={t('rules.description.forth')} />
          <RuleItem
            icon={<Alert02Icon />}
            text={t('rules.description.fives')}
          />
        </ul>
        <h3 className="text-sm font-bold">{t('rules.footer')}</h3>
      </div>
    </ModalDialog>
  );
}

RulesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RulesDialog;
